/* eslint-disable eslint-comments/disable-enable-pair -- remove warning */
/* eslint-disable no-unsafe-optional-chaining -- remove warning */
/* eslint-disable complexity -- needed */
/* eslint-disable no-sequences -- needed */
/* eslint-disable no-unused-expressions -- needed */

import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  getSelectedProduct,
  getProductRegistryById,
  getProductAccountKey,
} from '@americanexpress/product-ducks';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { useModule } from '@americanexpress/holocron-hooks';
import {
  useReactlytics,
  ExtendReactlytics,
} from '@americanexpress/reactlytics';
import { generateUrls } from '@americanexpress/axp-benefits-utils';
import { Link } from '@americanexpress/one-app-router';
import { fromJS } from 'immutable';
import {
  Button,
  CallToAction,
  ContinuousLinearTracker,
  Heading,
  IconButton,
  Modal,
  ModalBody,
  ModalHeader,
  Surface,
  ButtonBase,
} from '@americanexpress/dls-react';
import { IconChevronLeft, IconChevronRight } from '@americanexpress/dls-icons';
import style from '@americanexpress/web-react-extensions/styles/viewAll.scss';
import { renderHtml } from '../../view-all/components/card-benefits-tile/utils/render-html';
import EnrollStatus from '../../view-all/components/card-benefits-tile/enrollstatus/EnrollStatus';
import {
  getApiEndpoint, getEndpoint, getReadBenefitsRequestBody,
  getReadBestLoyaltyBenefitsTrackers,
} from '../../../api/api-utils';
import AnalyticsClick from '../../shared/components/analyticsClick';
import mockConfig from '../../../../jest/mock/mockConfig.json';
import useOneData from '../../../hooks/useOneData';
import TrackersQuickView from './TrackersQuickView';
import {
  benefitTermsTitle,
  benefitTermsText,
  assuranceTitle,
  assuranceText,
  ReadLoyaltyBenefitsVx,
} from '../../../constants';

import {
  concatDisclosures,
  getDisclosureHeading,
} from '../../view-all/components/card-benefits-tile/utils';
import UnifiedTracker from './UnifiedTracker';
import WarningModal from './WarningModal';

export function QuickView(props) {
  const intl = useIntl(); // Hook for accessing locale content, intl.formatMessage()
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  // Quick View props
  const toggleModal = props?.toggleModal;
  const refreshBenefitsData = props?.refreshBenefitsData;
  const closeButtonLabel = props?.closeButtonLabel;
  const dismissible = props?.dismissible;
  const modalDialogRef = props?.modalDialogRef;
  const cardname = props?.cardname;
  const title = props?.title;
  const prevTitle = props?.prevTitle;
  const nextTitle = props?.nextTitle;
  const copy = props?.copy;
  const showStatus = props?.showStatus;
  const statusLabel = props?.statusLabel;
  const enrollmentApplicationStatus = props?.enrollmentApplicationStatus;
  const showEnroll = props?.showEnroll;
  const enrollLabel = props?.enrollLabel;
  const enrollHref = props?.enrollHref;
  const showExternal = props?.showExternal;
  const externalLabel = props?.externalLabel;
  const normalizedBenefit = props?.typeOfTerms;
  const externalHref = props?.externalHref;
  const detailRequiresLogin = props?.detailRequiresLogin;
  const login = props?.login;
  const sorBenefitId = props?.sorBenefitId;
  const localeFilename = props?.env;
  const accountToken = props?.accountToken;
  const faasApiUrl = props?.faasApiUrl;
  const catCTA = props?.catCTA;
  const resyModuleProps = props?.resyModuleProps;
  const showResy = props?.enrollType === 'PARTNER-LINKING';

  // for meta tracker mock replace apiUrl with 'ReadLoyaltyBenefitsTrackers' and functionName with 'ReadLoyaltyBenefitsTrackers.v2' and replace 'best' mode with 'ID' in NewViewAllPage under axp-benefits-trackers
  const apiUrl = getApiEndpoint(
    mockConfig.USE_LOCAL_TRACKER_DATA,
    localeFilename,
    faasApiUrl,
    'ReadBestLoyaltyBenefitsTrackers'
  );
  const functionName = 'ReadBestLoyaltyBenefitsTrackers.v1';
  const endpoint = `${apiUrl}/${functionName}`;
  const trackerLimitString = typeof props?.trackerLimit === 'number'
    ? `${props?.trackerLimit}`
    : props?.trackerLimit;
  const benefitID = '';
  const locale = intl.locale;
  const benefitName = props?.benefitName;
  const name = props?.name?.name;
  const rejectedmessage = props?.rejectedmessage;
  const productType = props?.productType;
  const { track } = useReactlytics();
  let includesDisclosures = !!normalizedBenefit?.disclosures;
  const [disclosureHeading, setDisclosureHeading] = useState('');
  const [disclosureDescription, setDisclosureDescription] = useState([]);
  const [termsTitle, setTermstitle] = useState('');
  const spanRef = useRef(null);
  const [qvEvent, setqvEvent] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => {
    setqvEvent(!qvEvent);
  };
  const [showWarningModal, setShowWarningModal] = useState(false);
  const memoizedCardName = useMemo(() => {
    return `${cardname?.replace(/ /g, '-').toLowerCase()}>>qv-pcta-enroll`;
  }, [cardname]);

  const { data: trackerData } = useOneData(
    `${endpoint}`,
    getReadBestLoyaltyBenefitsTrackers(
      accountToken,
      functionName,
      trackerLimitString,
      benefitID,
      locale
    )
  );

  const requestBody = getReadBenefitsRequestBody(accountToken, cardname, login, productType, locale);
  const { data: benefitsData, run: runBenefits } = useOneData(
    getEndpoint(faasApiUrl, ReadLoyaltyBenefitsVx),
    {
      body: requestBody,
    }
  );

  const { Module: TaskFlowModal } = useModule('axp-task-flow-wrapper');
  const { Module: ResyLinking } = useModule('axp-resy-linking');
  const onClose = () => {
    setIsOpen(false);
  };
  const onSubmit = () => {
    runBenefits();
    refreshBenefitsData(benefitsData);
    setIsOpen(false);
  };
  const showResyLinkWrapper = () => {
    return (
      <TaskFlowModal
        variant="modal"
        isOpen={isOpen}
        onClose={onClose}
        title="resy-linking"
      >
        <ResyLinking
          locale={locale}
          benefitData={resyModuleProps}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </TaskFlowModal>
    );
  };

  useEffect(() => {
    if (includesDisclosures) {
      // Checks for empty array, arr[]
      if (normalizedBenefit?.disclosures.length === 0) {
        includesDisclosures = false;
      }
      // Checks for a null in the array, arr[null]
      if (normalizedBenefit?.disclosures[0] === null) {
        includesDisclosures = false;
      }
    }
    if (includesDisclosures) {
      setDisclosureHeading(
        getDisclosureHeading(normalizedBenefit?.disclosures[0].type)
      );
      setDisclosureDescription(
        concatDisclosures(normalizedBenefit?.disclosures)
      );
    }
    if (termsTitle === 'AMEX Assurance Company Disclosures') {
      setqvEvent(true);
    } else {
      setqvEvent(false);
    }
  }, [includesDisclosures, normalizedBenefit, termsTitle]);

  useEffect(() => {
    if (rejectedmessage && spanRef.current) {
      const reEnrollment = rejectedmessage && (catCTA || showEnroll || showExternal);
      impressionFire(`>>qv>>${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}-unsuccessful-${reEnrollment ? 'enroll-cta-visible' : 'enroll-cta-not-visible'}`, 'click', rejectedmessage);
    }
  }, [rejectedmessage]);

  const trackingClick = (nextORprev) => {
    const clickDirection = nextORprev === 'prev' ? prevTitle : nextTitle;
    setTimeout(() => {
      track({
        event: {
          element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>quickview`,
          type: 'impression',
          meta: {
            benefitname: `${parseEntities(clickDirection)?.replace(/ /g, '-').toLowerCase()}`,
          },
        },
      });
    }, 1);
  };

  const impressionFire = (msg, type, detail) => {
    setTimeout(() => {
      track({
        event: {
          element: `${cardname?.replace(/ /g, '-').toLowerCase()}${msg}`,
          type,
          detail,
          meta: {
            benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}`,
          },
        },
      });
    }, 1);
  };

  // filter out only trackers that contain metaContent and return one new array
  const trackersWithMetaContent = trackerData?.[0]?.trackers?.filter(
    (tracker) => tracker?.metaContent
  );

  // map through trackersWithMetaContent and return a new array of trackers with the same sorBenefitId
  const trackersWithSameSorBenefitId = trackersWithMetaContent?.filter(
    (tracker) => tracker?.sorBenefitId === sorBenefitId
  );

  // map over each array and return a new array by the metaContent order key in ascending order
  const sortedTrackers = trackersWithSameSorBenefitId?.sort(
    (a, b) => a?.metaContent?.order - b?.metaContent?.order
  );

  const progressData = findProgressData(
    trackerData?.[0]?.trackers,
    sorBenefitId
  );
  const isCurrency = progressData?.tracker?.targetUnit === 'MONETARY';
  const handleNext = props?.handleNext;
  const handlePrevious = props?.handlePrevious;

  // filter sortedTracker return new array of trackers that have a metaContent category of 'access'
  const accessMetaTracker = sortedTrackers?.filter(
    (tracker) => tracker?.metaContent?.linked[0]?.trackerCategory === 'access'
  );

  // filter sortedTracker return new array of trackers that do not have a metaContent category of 'access'
  const noAccessMetaTracker = sortedTrackers?.filter(
    (tracker) => tracker?.metaContent?.linked[0]?.trackerCategory !== 'access'
  );

  // i18n format currency vs non-currency
  const formattedAmount = (amount) => {
    let amnt = amount <= 0 ? 0 : amount;
    const convertToInt = Math.round(amnt).toLocaleString();

    // Temporary Fix....issue with intl...props are showing as undefined..locale, lang, formatNumber
    const numberOptions = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };

    if (isCurrency) {
      return `${trackerData[0]?.trackers[0]?.tracker?.targetCurrencySymbol}${convertToInt}`;
    }
    return intl?.formatNumber(amnt, numberOptions);
  };

  const textFormatter = (inputText) => {
    const formatText = (text) => {
      // eslint-disable-next-line unicorn/no-unsafe-regex -- remove warning
      return text.replace(/\d+(\.\d+)?/, (match) => {
        // Convert the matched integer part to a number, removing the decimals, if any.
        const formattedNumber = Number.parseFloat(match, 10).toLocaleString();
        return formattedNumber;
      });
    };

    const formattedText = formatText(inputText);

    return formattedText;
  };

  // accessMetaTracker html
  const spendMetaTrackerProgressBar = () => {
    const spentAmount = progressData?.tracker?.spentAmount;
    const targetAmount = progressData?.tracker?.targetAmount;
    const remainingAmount = progressData?.tracker?.remainingAmount;
    const formattedSpentAmount = `${formattedAmount(spentAmount)}`;
    const formattedRemainingAmount = spentAmount === targetAmount
      ? null
      : formattedAmount(remainingAmount);
    const leftLabel = progressData?.metaContent?.content?.detail?.leftLabel;
    const rightLabel = spentAmount === targetAmount
      ? null
      : progressData?.metaContent?.content?.detail?.rightLabel;
    return (
      <ContinuousLinearTracker
        className="margin-2-t"
        labelOverrides={{
          getScreenReaderLabel: () => 'Progress in attaining this reward',
          getScreenReaderValueText: () => formattedSpentAmount,
          getTrackerEndText: () => `${formattedRemainingAmount} ${rightLabel}`,
          getTrackerStartText: () => `${formattedSpentAmount} ${leftLabel}`,
        }}
        max={targetAmount}
        min={0}
        value={spentAmount}
      />
    );
  };

  const showMetaTrackerAccess = () => {
    if (!progressData.metaContent) {
      return (
        <OnVisible
          analyticsInfo={{
            type: 'impression',
            element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>qv-tracker-bar`,
            meta: {
              benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}`,
            },
          }}
        >
          <Surface variant="fg-subtle" className="radius-container border margin-2-tb pad-3">
            <TrackersQuickView
              trackerData={progressData}
              isCurrency={isCurrency}
            />
          </Surface>
        </OnVisible>
      );
    }
    return accessMetaTracker?.map((tracker) => {
      if (
        progressData.metaContent
        && progressData.metaContent?.linked[0]?.trackerCategory === 'access'
      ) {
        return (
          <Surface key={tracker.id} variant="fg-subtle" className="radius-container border margin-2-tb pad-3">
            <OnVisible
              analyticsInfo={{
                type: 'impression',
                element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>qv-tracker-bar`,
                meta: {
                  benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}`,
                },
              }}
            >
              <Heading level={2} variant="sans-xsmall-bold">
                {tracker?.metaContent?.content?.detail?.progress?.heading}
              </Heading>
              {spendMetaTrackerProgressBar()}
              <div className="pad-2-t">
                {textFormatter(
                  tracker?.status === 'ACHIEVED'
                    ? tracker.metaContent?.content?.detail?.achieved
                      ?.statusMsg
                    : tracker.metaContent?.content?.detail?.progress
                      ?.statusMsg
                )}
              </div>
            </OnVisible>
          </Surface>
        );
      }
      return null;
    });
  };

  // if tracker category is not access, show tracker
  const showMetaTrackerNoAccess = () => {
    return noAccessMetaTracker?.map((tracker) => {
      if (
        progressData?.metaContent
        && tracker?.metaContent?.linked[0]?.trackerCategory !== 'access'
      ) {
        return (
          <Surface key={tracker.id} variant="fg-subtle" className="radius-container border margin-2-tb pad-3">
            <Heading level={2} variant="sans-xsmall-bold">
              {tracker?.metaContent?.content?.detail?.progress?.heading}
            </Heading>
            {renderHtml(
              tracker?.status === 'ACHIEVED'
                ? tracker.metaContent?.content?.detail?.achieved?.statusMsg
                : tracker.metaContent?.content?.detail?.progress?.statusMsg
            )}
          </Surface>
        );
      }
      return null;
    });
  };

  const showUnifiedTracker = () => {
    return <UnifiedTracker trackers={sortedTrackers} progressData={progressData} isCurrency={isCurrency} />;
  };

  const sortMetaTrackers = () => {
    if (sortedTrackers.length === 2) {
      return (
        <>
          {showUnifiedTracker()}
        </>
      );
    }
    if (accessMetaTracker[0]?.metaContent?.order === 1) {
      return (
        <div className="stack-3-lg-up stack-1">
          {showMetaTrackerAccess()}
          {showMetaTrackerNoAccess()}
        </div>
      );
    }
    return (
      <>
        {showMetaTrackerNoAccess()}
        {showMetaTrackerAccess()}
      </>
    );
  };

  function findProgressData(data, sorBenefitIdFromProps) {
    return data?.reduce((accumulator, currentItem) => {
      if (!accumulator && currentItem?.sorBenefitId === sorBenefitIdFromProps) {
        return currentItem;
      }
      return accumulator;
    }, null);
  }

  useEffect(() => {
    if (normalizedBenefit?.disclosures?.[0]?.type === benefitTermsTitle) {
      setTermstitle(benefitTermsText);
    } else if (normalizedBenefit?.disclosures?.[0]?.type === assuranceTitle) {
      setTermstitle(assuranceText);
    }
  }, [normalizedBenefit]);

  let quickViewCopy = copy;
  // Change message for logged in only benefits, if looged out
  if (detailRequiresLogin && !login) {
    quickViewCopy = `${intl.formatMessage({ id: 'view-all.quick-view.login-message' })}`;
  }

  // Check to exclude any trackers that should not show on quick view
  let excludeTracker = false;
  switch (sorBenefitId) {
    // Platinum Walmart+
    case '59eb0cee-ce1d-47fb-86aa-1fa2a94dd92a':
      excludeTracker = true;
      break;
    // Business Gold Walmart+
    case '75897475-46dc-49b7-8fa1-261c6a4d5da1':
      excludeTracker = true;
      break;
    default:
      excludeTracker = false;
  }

  // Also exclude tracker for the airline-bonus benefit, which shares the same sorBenefitID with two other benefits
  if (benefitName === 'airline-bonus') {
    excludeTracker = true;
  }

  // Quick view tracker analytics
  useEffect(() => {
    if (title) {
      if (typeof track === 'function' && sorBenefitId && !excludeTracker) {
        setTimeout(() => { }, 1);
      }
    }
  }, [title]);

  // Carousal arrow accessibility via keyboard
  useEffect(() => {
    const handleKeyNavigation = (e) => {
      if (e.keyCode === 37) {
        handlePrevious();
      } else if (e.keyCode === 39) {
        handleNext();
      }
    };

    window.addEventListener('keyup', handleKeyNavigation);
    return () => {
      window.removeEventListener('keyup', handleKeyNavigation);
    };
  }, [handleNext, handlePrevious]);

  useEffect(() => {
    if (title) {
      let event = {
        event: {
          type: 'impression',
          element: `${parseEntities(cardname)?.replace(/ /g, '-').toLowerCase()}>>qv-tracker-text`,
          meta: {
            benefitname: parseEntities(title)?.replace(/ /g, '-').toLowerCase(),
          },
        },
      };
      if (
        progressData?.metaContent
        && noAccessMetaTracker[0]?.metaContent?.linked[0]?.trackerCategory
        !== 'access'
      ) {
        if (typeof track === 'function' && sorBenefitId && !excludeTracker) {
          setTimeout(() => {
            track(event);
          }, 1);
        }
      }
    }
  }, [title]);

  const renderCTAForExternalLink = () => {
    if (locale === 'en-CA' || locale === 'fr-CA') {
      return (
        <div>
          <Button
            className={style.modalBtn}
            onClick={() => setShowWarningModal(true)}
            aria-label={parseEntities(`${enrollHref} ${title}`)}
            data-testid="enroll-link"
          >
            {catCTA?.label}
          </Button>
        </div>
      );
    }
    return (
      <CallToAction
        data-testid="enroll-link"
        variant="primary"
        href={enrollHref}
      >
        {catCTA?.label}
      </CallToAction>
    );
  };

  const showMetaTrackers = sorBenefitId
    && !excludeTracker
    && login
    && trackerData
    && progressData;

  const containerScrollRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      impressionFire('>>qv>>container-scroll', 'impression');
    };
    const container = containerScrollRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll, { passive: true });
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const quickViewCopyRef = useRef(null);
  const hasLoggedImpression = useRef(false);

  /* istanbul ignore next */
  useEffect(() => {
    const handleScroll = () => {
      const el = quickViewCopyRef.current;
      if (!el) return;
      if (el.scrollTop > 0 && !hasLoggedImpression.current) {
        impressionFire('>>quickview', 'impression');
        hasLoggedImpression.current = true;
      } else if (el.scrollTop === 0 && hasLoggedImpression.current) {
        hasLoggedImpression.current = false;
      }
    };
    const el = quickViewCopyRef.current;
    if (el) {
      el.addEventListener('scroll', handleScroll, { passive: true });
    }
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <OnVisible
      analyticsInfo={{
        type: 'impression',
        element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>quickview`,
        meta: {
          benefitname: `${parseEntities(name)?.replace(/ /g, '-').toLowerCase()}`,
        },
      }}
    >
      <Modal
        role="dialog"
        aria-modal={true}
        title="quick view"
        aria-labelledby="quick-view-header"
        aria-describedby="quick-view-body"
        onClose={toggleModal}
        ref={modalDialogRef}
        innerContainerClassName="col-md-12"
      >
        <div
          className="position-relative"
          data-toggle="carousel"
          data-autoplay="false"
          data-animate="true"
          aria-labelledby="benefit-carousel"
        >
          <div
            className={`col-md-9 margin-auto-lr flex flex-column ${style.carousalHeight}`}
          >
            <ExtendReactlytics
              analytics={{
                event: {
                  meta: {
                    benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}`,
                  },
                },
              }}
            >
              <ModalHeader
                id="quick-view-header"
                className="flex-justify-end radius-container-t"
                hideCloseButton={!dismissible}
                closeButtonProps={{
                  reactlytics: {
                    element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>quickview>>close`,
                  },
                }}
                reactlytics={{ disable: true }}
                labelOverrides={{
                  closeButtonScreenReaderLabel: closeButtonLabel,
                }}
              />
            </ExtendReactlytics>
            <ModalBody id="quick-view-body" className={`radius-container-b ${style.modalContent} pad-responsive pad-3-lg-down`}>
              <img
                src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/brand/centurion-linear-deepblue.svg"
                className={`flex flex-justify-end ${style.modalBackground}`}
                alt="centurion-logo"
              />
              <div className={`${style.carousalArrow}`}>
                <div className="row margin-0-lr pad-0-lr width-full flex flex-justify-between">
                  <div className="col-md-12 pad-0-lr flex flex-align-items-center flex-justify-between">
                    <Heading
                      level={1}
                      variant="sans-medium-bold"
                      className={`${!showStatus ? '' : 'margin-1-b'}`}
                    >
                      {renderHtml(title)}
                    </Heading>
                    {catCTA && showEnroll && !showExternal && !showResy && (
                      <AnalyticsClick element={memoizedCardName} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                        {enrollHref?.startsWith('/card-benefits') ? (
                          <CallToAction
                            variant="primary"
                            asChild={true}
                          >
                            <Link
                              to={`${window.location.origin + enrollHref}`}
                              aria-label={parseEntities(`${`${catCTA?.label} ${title}`}`)}
                              data-testid="enroll-link"
                            >
                              {catCTA?.label}
                            </Link>
                          </CallToAction>
                        )
                          : renderCTAForExternalLink()}
                      </AnalyticsClick>
                    )}
                    {catCTA && !showEnroll && showExternal && !showResy && (
                      <AnalyticsClick element={memoizedCardName} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                        { locale === 'en-CA' || locale === 'fr-CA' ? (
                          <div>
                            <Button
                              className={`${style.modalBtn}`}
                              onClick={() => setShowWarningModal(true)}
                              aria-label={parseEntities(`${`${externalLabel} ${title}`}`)}
                              data-testid="external-link"
                            >
                              {externalLabel}
                            </Button>
                          </div>

                        )
                          : (
                            <CallToAction
                              className={`${style.modalBtn}`}
                              href={externalHref}
                              rel="noreferrer"
                              aria-label={parseEntities(`${`${externalLabel} ${title}`}`)}
                              data-testid="external-link"
                            >
                              {externalLabel}
                            </CallToAction>
                          )}

                      </AnalyticsClick>
                    )}
                    {catCTA && !showEnroll && !showExternal && !showResy && (
                      <AnalyticsClick element={memoizedCardName} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
                        <CallToAction asChild={true}>
                          <Link
                            to={`${window.location.origin + catCTA?.link}`}
                            className={`${style.modalBtn}`}
                            aria-label={parseEntities(`${`${catCTA?.label} ${title}`}`)}
                            data-testid="enroll-link"
                          >
                            {catCTA?.label}
                          </Link>
                        </CallToAction>
                      </AnalyticsClick>
                    )}
                    {catCTA && showResy && (
                      <div>
                        <Button
                          variant="primary"
                          onClick={() => setIsOpen(true)}
                          className={style.modalBtn}
                          data-testid="resy-linking-btn"
                        >
                          {catCTA?.label}
                        </Button>
                        {TaskFlowModal && ResyLinking && isOpen && showResyLinkWrapper()}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-content-between col-12 col-md-12 pad-0-lr ">
                    <div
                      className={`col-md-12 pad-0-lr ${showStatus || rejectedmessage ? 'flex' : ''} flex-justify-between`}
                    >
                      <div>
                        {rejectedmessage ? (
                          <span ref={spanRef}>
                            <img
                              src="https://www.aexp-static.com/akamai/one/statics/@americanexpress/dls-icons/1.2.1/package/dist/svg/warning.outline.svg"
                              style={{
                                filter:
                                  'invert(20%) sepia(95%) saturate(5581%) hue-rotate(0deg) brightness(94%) contrast(107%)',
                                width: '20px',
                              }}
                              alt="Warning Icon"
                            />
                            {rejectedmessage}
                          </span>
                        )
                          : showStatus && (
                            <div className="margin-1-b margin-2-r">
                              <EnrollStatus
                                labelClass="body-small-bold pad-1-l"
                                label={statusLabel}
                                enrollmentApplicationStatus={
                                  enrollmentApplicationStatus
                                }
                                enrolledStatus="true"
                              />
                            </div>
                          )}
                      </div>

                      <div
                        className={`${!showStatus ? 'flex flex-justify-between flex-align-center flex-row-reverse' : ''}`}
                      >
                        {!catCTA && showEnroll && global.BROWSER && (
                          <AnalyticsClick
                            element={memoizedCardName}
                            benefitNameTag={parseEntities(title)
                              ?.replace(/ /g, '-')
                              .toLowerCase()}
                          >
                            <CallToAction
                              variant="primary"
                              asChild={true}
                            >
                              <Link
                                to={`${window.location.origin + enrollHref}`}
                                className={`${style.modalBtn}`}
                                aria-label={parseEntities(
                                  `${`${intl.formatMessage({ id: 'view-all.card-benefits-tile.get-started' })} ${title}`}`
                                )}
                                data-testid="enroll-link"
                              >
                                {enrollLabel}
                              </Link>
                            </CallToAction>
                          </AnalyticsClick>
                        )}
                        {!catCTA && showExternal && (
                          <AnalyticsClick
                            element={memoizedCardName}
                            benefitNameTag={parseEntities(title)
                              ?.replace(/ /g, '-')
                              .toLowerCase()}
                          >
                            { locale === 'en-CA' || locale === 'fr-CA' ? (
                              <div>
                                <Button
                                  className={`${style.modalBtn}`}
                                  onClick={() => setShowWarningModal(true)}
                                  aria-label={parseEntities(`${`${intl.formatMessage({ id: 'view-all.card-benefits-tile.get-started' })} ${title}`}`
                                  )}
                                  data-testid="external-link"
                                >
                                  {externalLabel}
                                </Button>
                              </div>

                            ) : (
                              <CallToAction
                                className={`${style.modalBtn}`}
                                href={externalHref}
                                rel="noreferrer"
                                aria-label={parseEntities(`${`${externalLabel} ${title}`}`)}
                                data-testid="external-link"
                              >
                                {externalLabel}
                              </CallToAction>
                            ) }

                          </AnalyticsClick>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-justify-start flex-align-start flex-column">
                    <Button
                      variant="tertiary"
                      id="expandable1"
                      data-testid="ben-terms"
                      className="pad-2-l pad-2-b margin-2-b"
                      onClick={() => {
                        handleToggle(),
                        impressionFire(
                          `>>qv>>${qvEvent ? 'open-benefit-terms' : 'close-benefit-terms'}`, 'click'
                        );
                      }}
                      aria-label="Show Details about rewards points"
                      aria-expanded="false"
                    >
                      {intl.formatMessage({
                        id: `view-all.quick-view.${qvEvent ? 'hide' : 'view'}-${termsTitle.replace(/ /g, '-').toLowerCase()}`,
                        defaultMessage: `${qvEvent ? 'Hide' : 'View'} ${termsTitle}`,
                      })}
                    </Button>
                    {qvEvent ? (
                      <div
                        aria-labelledby="expandable1"
                        className="accordion-content"
                      >
                        <ButtonBase
                          className={`${style.termsStyle} text-align-left`}
                          aria-label="Scrollable content"
                        >
                          <Heading level={2} variant="sans-xsmall-bold">
                            {typeof disclosureHeading === 'string'
                              && disclosureHeading.includes(
                                'Amex Assurance Disclosures'
                              ) ? (
                                <FormattedMessage
                                  id="shared.terms-links.disclosures"
                                  defaultMessage="AMEX Assurance Company Disclosures"
                                />
                              ) : null}
                          </Heading>
                          <p
                            className={`body-small pad-1-t pad-2-b ${style.card}`}
                          >
                            {renderHtml(disclosureDescription)}
                          </p>
                        </ButtonBase>
                      </div>
                    )
                      : ''}
                  </div>
                </div>
                <hr className="margin-3-b-lg-up margin-3-b" />
                {showMetaTrackers && sortMetaTrackers()}
                <div>
                  <ButtonBase
                    id="containerScroll"
                    ref={containerScrollRef}
                    aria-label="Scrollable content"
                    className={
                      `
                      ${showMetaTrackers ? 'margin-3-t-lg-up margin-2-t' : ''}
                      text-align-left`
                    }
                  >
                    <Heading level={2} variant="sans-xsmall-bold">
                      <FormattedMessage
                        id="view-all.quick-view.copy-heading"
                        defaultMessage="Benefit Details"
                      />
                    </Heading>
                    <p
                      ref={quickViewCopyRef}
                      className={`width-full body-small pad-1-t pad-2-b ${style.bodyContainer}`}
                      style={{ maxHeight: '200px', overflowY: 'auto' }}
                    >
                      {renderHtml(quickViewCopy)}
                    </p>
                  </ButtonBase>
                </div>
              </div>
            </ModalBody>
          </div>

          <div className={`${style.carouselControls} flex flex-justify-between position-absolute width-full pointer-events-none`}>
            <ExtendReactlytics
              analytics={{
                event: {
                  meta: {
                    benefitname: `${parseEntities(prevTitle)?.replace(/ /g, '-').toLowerCase()}`,
                  },
                },
              }}
            >
              <IconButton
                shape="square"
                data-testid="carousalButtonPrevious"
                variant="secondary"
                aria-label="Previous"
                id={`${style.carousalPreviousButton}`}
                className="pointer-events-auto margin-2"
                data-control="prev"
                onClick={() => {
                  if (handlePrevious) handlePrevious();
                  trackingClick('prev');
                }}
                reactlytics={{
                  element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>quickview>>previous`,
                }}
              >
                <IconChevronLeft size="md" color="brand" />
              </IconButton>
            </ExtendReactlytics>
            <ExtendReactlytics
              analytics={{
                event: {
                  meta: {
                    benefitname: `${parseEntities(nextTitle)?.replace(/ /g, '-').toLowerCase()}`,
                  },
                },
              }}
            >
              <IconButton
                shape="square"
                data-testid="carousalButtonNext"
                variant="secondary"
                aria-label="Next"
                id={`${style.carousalNextButton}`}
                className="pointer-events-auto margin-2"
                data-control="next"
                reactlytics={{
                  element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>quickview>>next`,
                }}
                onClick={() => {
                  if (handleNext) handleNext();
                  trackingClick('next');
                }}
              >
                <IconChevronRight size="md" color="brand" />
              </IconButton>
            </ExtendReactlytics>
            <div aria-live="polite" aria-atomic="true" className="sr-only" />
          </div>
        </div>
        {showWarningModal && (
          <WarningModal open={showWarningModal} externalLink={externalHref || enrollHref} handleClose={() => setShowWarningModal(false)} warningMessage="You are about to enter a third-party website where all use is governed by that website's Terms and Conditions and subject to its Privacy and Security policies and practices." />
        )}
      </Modal>
    </OnVisible>
  );
}
export function mapStateToProps(state) {
  const env = fromJS(state).getIn(['config', 'localeFilename']);
  const product = getSelectedProduct(state);
  return {
    faasApiUrl: fromJS(state).getIn(['config', 'faasApiUrl']),
    CENTURION_LOGIN_URL: generateUrls(env).CENTURION_LOGIN_URL,
    MYCA_LOGIN_URL: generateUrls(env).MYCA_LOGIN_URL,
    domain: fromJS(state).getIn(['config', 'domainGlobal']),
    login: Boolean(getSelectedProduct(state)),
    accountToken: getSelectedProduct(state),
    accountKey: getProductAccountKey(state),
    productRegistry: getProductRegistryById(state, getSelectedProduct(state)),
    productType: getProductRegistryById(state, product)?.type,
  };
}

export const ComponentUnderTest = QuickView;
export default connect(mapStateToProps, null)(QuickView);
